export enum CRMPlatform {
  HUBSPOT = "HUBSPOT",
}
